// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m8J-Q","certified":"styles_certified__epKVp","pending":"styles_pending__STrTd","denied":"styles_denied__tBJfy","waiting":"styles_waiting__bPNGo"};